import AppCatalog from "@/services/App/AppCatalog.js";

export default {
  Copyright: AppCatalog.Copyright,
  Description: AppCatalog.Description,
  Welcome: "Hello, Welcome"
}